import type { QualityPreset } from './types';

export const QUALITY_PRESETS: Record<'low' | 'high', QualityPreset> = {
  low: {
    id: 'low',
    dpr: [1, 1.15],
    shadows: false,
    bloom: true,
    antialias: false,
    maxPunctualLights: 3,
    floodProps: false,
    bloomIntensity: 0.12,
  },
  high: {
    id: 'high',
    dpr: [1, 1.75],
    shadows: true,
    bloom: true,
    antialias: true,
    maxPunctualLights: 8,
    floodProps: true,
    bloomIntensity: 0.32,
  },
};

export function detectQuality(): QualityPreset {
  if (typeof window === 'undefined') return QUALITY_PRESETS.high;

  const params = new URLSearchParams(window.location.search);
  const q = params.get('q');
  if (q === 'low') return QUALITY_PRESETS.low;
  if (q === 'high') return QUALITY_PRESETS.high;

  const coarse =
    window.matchMedia('(pointer: coarse)').matches ||
    navigator.maxTouchPoints > 0;
  const small = Math.min(window.innerWidth, window.innerHeight) < 700;
  const lowMem =
    'deviceMemory' in navigator &&
    typeof (navigator as Navigator & { deviceMemory?: number }).deviceMemory ===
      'number' &&
    ((navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 8) <= 4;

  if (coarse || small || lowMem) return QUALITY_PRESETS.low;
  return QUALITY_PRESETS.high;
}

/** Lane run auto-advance after this many seconds if player hasn't reached the shot. */
export const RUN_TIMEOUT_SEC = 210;

/** Distance along Z (meters) that triggers the shot-aim break. */
export const RUN_END_Z = -145;

export const TACKLE_TELL_SEC = 0.5;
export const CORE_REVEAL_SEC = 2.2;
export const FLASH_CUT_MS = 100;
export const KEEPER_TELL_MS = 500;
export const SIGNATURE_NUMBER = 10;
export const REAL_NAME = 'ADARSH DHAWALE';

export const MOVE_SPEED = 6.2;
export const SPRINT_MULT = 1.35;
export const LOOK_SENS = 0.0022;
export const TOUCH_LOOK_SENS = 0.0034;
